<template>
	<div>
		<h1>
			Settings
		</h1>

		<div class="alert alert-danger" v-if="error">
			<p class="mb-0">
				{{ error }}
			</p>
		</div>

		<!-- <div class="row">
			<div class="col">
				<h2 class="mt-2">
					Company Info
				</h2>
			</div>
			<div class="col-auto">
				<locale-switcher @change="fetchAgain" />
			</div>
		</div>
		<div class="form-group">
			<label for="about-company">
				<small class="text-muted">ABOUT COMPANY</small>
			</label>
			<textarea class="form-control" name="about-company" placeholder="About Company" v-model="settings.about"
				required autofocus>
			</textarea>
		</div>
		<div class="form-group">
			<label for="company-message">
				<small class="text-muted">COMPANY MESSAGE</small>
			</label>
			<textarea class="form-control" name="company-message" placeholder="Company Message"
				v-model="settings.message" required autofocus>
			</textarea>
		</div> -->
		<!-- <div class="form-group">
			<label for="shipping-cities">
				<small class="text-muted">SHIPPING CITIES</small>
			</label>
			<multiselect v-model="settings.shipping_cities" :close-on-select="false" :options="settings.shipping_cities"
				placeholder="Search or add a shipping city" tag-placeholder="Add a new shipping city" multiple taggable
				@tag="shipping_city => settings.shipping_cities.push(shipping_city)" />
		</div>
		<div class="form-group">
			<label for="nonshipping-cities">
				<small class="text-muted">NON-SHIPPING CITIES</small>
			</label>
			<multiselect v-model="settings.nonshipping_cities" :close-on-select="false"
				:options="settings.nonshipping_cities" placeholder="Search or add a non-shipping city"
				tag-placeholder="Add a new non-shipping city" multiple taggable
				@tag="nonshipping_city => settings.nonshipping_cities.push(nonshipping_city)" />
		</div> -->
		<div class="form-group">
			<label for="shipping-cost">
				<small class="text-muted">SHIPPING COST</small>
			</label>
			<input type="text" class="form-control" name="shipping-cost" placeholder="Shipping cost per one roll"
				v-model="settings.shipping_cost" required autofocus />
		</div>

		<div class="row">
			<div class="col">
				<h2 class="mt-2">
					Contact Info
				</h2>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="form-group">
					<label for="email">
						<small class="text-muted">EMAIL</small>
					</label>
					<input type="text" class="form-control" name="email" placeholder="Email" v-model="settings.email"
						required autofocus />
				</div>
			</div>
			<div class="col">
				<div class="form-group">
					<label for="facebook">
						<small class="text-muted">FACEBOOK</small>
					</label>
					<input type="text" class="form-control" name="facebook" placeholder="Facebook"
						v-model="settings.facebook" required autofocus />
				</div>
			</div>
			<!-- <div class="col">
				<div class="form-group">
					<label for="linkedin">
						<small class="text-muted">LINKEDIN</small>
					</label>
					<input type="text" class="form-control" name="linkedin" placeholder="LinkedIn"
						v-model="settings.linkedin" required autofocus />
				</div>
			</div> -->
		</div>
		<div class="row">
			<div class="col">
				<div class="form-group">
					<label for="instagram">
						<small class="text-muted">INSTAGRAM</small>
					</label>
					<input type="text" class="form-control" name="instagram" placeholder="Instagram"
						v-model="settings.instagram" required autofocus />
				</div>
			</div>
			<!-- <div class="col">
				<div class="form-group">
					<label for="twitter">
						<small class="text-muted">TWITTER</small>
					</label>
					<input type="text" class="form-control" name="twitter" placeholder="Twitter"
						v-model="settings.twitter" required autofocus />
				</div>
			</div> -->
		</div>
		<!-- <div class="row">
			<div class="col">
				<div class="form-group">
					<label>
						<small class="text-muted">PHONES</small>
					</label>
					<multiselect v-model="settings.phone" :close-on-select="false" :options="settings.phone"
						placeholder="Search or add phone numbers" tag-placeholder="Add a new phone number" multiple
						taggable @tag="phone => settings.phone.push(phone)" />
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="form-group">
					<label>
						<small class="text-muted">ADDRESSES</small>
					</label>
					<multiselect v-model="settings.address" :close-on-select="false" :options="settings.address"
						placeholder="Search or add address" tag-placeholder="Add a new address" multiple taggable
						@tag="address => settings.address.push(address)" />
				</div>
			</div>
		</div> -->

		<button @click="save" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
			{{ loading ? 'Saving…' : 'Save' }}
			<div class="ld ld-ring ld-spin" />
		</button>

		<h2 class="mt-5">
			Branch Info
			<router-link :to="{name: 'create-branch-info'}" tag="button" type="button" class="btn btn-sm btn-primary">
				Create
			</router-link>
		</h2>
		<datatable class="mt-4" :cols="branchColumns" :rows="branchInfo" />

		<h2 class="mt-5">
			Slider Images
			<router-link :to="{name: 'create-slider-image'}" tag="button" type="button" class="btn btn-sm btn-primary">
				Create
			</router-link>
		</h2>
		<datatable class="mt-4" :cols="columns" :rows="sliderImages" />
<!-- 
		<h2 class="mt-5">
			Company Values
			<router-link :to="{name: 'create-company-value'}" tag="button" type="button" class="btn btn-sm btn-primary">
				Create
			</router-link>
		</h2>
		<datatable class="mt-4" :cols="valueColumns" :rows="companyValues" /> -->

		<h2 class="mt-5">
			Administrator Password
		</h2>
		<div class="form-group">
			<label for="password">
				<small class="text-muted">PASSWORD</small>
			</label>
			<input type="password" class="form-control" name="password" placeholder="Password" v-model="password"
				required autofocus />
		</div>
		<div class="form-group">
			<label for="password_confirmation">
				<small class="text-muted">CONFIRM PASSWORD</small>
			</label>
			<input type="password" class="form-control" name="password_confirmation" placeholder="Password confirmation"
				v-model="password_confirmation" required autofocus />
		</div>

		<button @click="savePassword" class="btn btn-primary ld-ext-right mt-3" :disabled="loading"
			:class="{running: loading}">
			{{ loading ? 'Saving…' : 'Save' }}
			<div class="ld ld-ring ld-spin" />
		</button>
	</div>
</template>

<script>
import store from '../../store';
import { mapState } from 'vuex';
import DataTable from '../DataTable';
import { createDatatableButtons, getError } from '../../helpers';
import Multiselect from 'vue-multiselect';
import LocaleSwitcher from '../LocaleSwitcher';
import { stat } from 'fs';

export default {
	components: {
		'datatable': DataTable,
		'multiselect': Multiselect,
		'locale-switcher': LocaleSwitcher,
	},

	data() {
		return {
			settings: {
				about: '',
				message: '',
				shipping_cities: [],
				nonshipping_cities: [],
				shipping_cost: '',

				email: '',
				facebook: '',
				instagram: '',
				linkedin: '',
				twitter: '',

				phone: [],
				address: [],
			},

			password: '',

			error: '',
			loading: false,

			columns: [
				{ headerName: 'ID', field: 'id', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 100 },
				{ headerName: 'Name' , field: 'name' , sortable: true , resizable: true, minWidth: 50},
				{
					headerName: 'Actions',
					field: 'id',
					minWidth: 175,
					maxWidth: 175,

					cellRenderer: params => {
						const buttons = [
							{
								name: 'View',
								type: 'secondary',
								handler: () => {
									window.open(params.data.link, '_blank');
								},
							},
						];

						buttons.push({
							name: 'Delete',
							type: 'danger',
							handler: () => {
								if (confirm('Are you sure you want to delete this slider image?')) {
									this.error = null;

									this.$store.dispatch('sliderImages/delete', { id: params.value })
										.catch(e => {
											this.error = getError(e);
										});
								}
							},
						});

						return createDatatableButtons(buttons);
					}
				}
			],

			valueColumns: [
				{ headerName: 'ID', field: 'id', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 100 },
				{ headerName: 'Content', field: 'title', sortable: true, filter: true, resizable: true, minWidth: 50, },
				{
					headerName: 'Actions',
					field: 'id',
					minWidth: 175,
					maxWidth: 300,

					cellRenderer: params => {
						const isDeleted = !!params.value.deleted_at;

						const buttons = [
							{
								name: 'View Image',
								type: 'secondary',
								handler: () => {
									window.open(params.data.image_url, '_blank');
								},
							},
							{
								name: 'Edit',
								type: 'primary',
								disabled: isDeleted,
								handler: () => {
									this.$router.push({ name: 'edit-company-value', params: { id: params.value } });
								}
							},
							{
								name: 'Delete',
								type: 'danger',
								handler: () => {
									if (confirm('Are you sure you want to delete this company value?')) {
										this.error = null;

										this.$store.dispatch('companyValues/delete', { id: params.value })
											.catch(e => {
												this.error = getError(e);
											});
									}
								},
							}
						];

						return createDatatableButtons(buttons);
					}
				}
			],
			branchColumns: [
				{ headerName: 'ID', field: 'id', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 100 },
				{ headerName: 'Branch Name', field: 'branches.name.en', sortable: true, filter: true, resizable: true, minWidth: 50, },
				{ headerName: 'Phones', field: 'phone', sortable: true, filter: true, resizable: true, minWidth: 50, },
				{ headerName: 'Address', field: 'address.en', sortable: true, filter: true, resizable: true, minWidth: 50, },
				{
					headerName: 'Actions',
					field: 'id',
					minWidth: 175,
					maxWidth: 300,

					cellRenderer: params => {
						const isDeleted = !!params.value.deleted_at;

						const buttons = [
							{
								name: 'Edit',
								type: 'primary',
								disabled: isDeleted,
								handler: () => {
									this.$router.push({ name: 'edit-branch-info', params: { id: params.value } });
								}
							},
							{
								name: 'Delete',
								type: 'danger',
								handler: () => {
									if (confirm('Are you sure you want to delete this Branch value?')) {
										this.error = null;

										this.$store.dispatch('branchInfo/delete', { id: params.value })
											.catch(e => {
												this.error = getError(e);
											});
									}
								},
							}
						];

						return createDatatableButtons(buttons);
					}
				}
			],
		};
	},

	computed: {
		...mapState({
			sliderImages: state => state.sliderImages.sliderImages,
			companyValues: state => state.companyValues.companyValues,
			branchInfo: state => state.branchInfo.branchInfo,
		}),
	},

	methods: {
		async fetchAgain() {
			this.loading = true;

			await store.dispatch('branchInfo/fetchAll');
			
			await axios.post('/api/settings', this.settings).catch(e => {
				this.loading = false;
				this.error = getError(e);
			});

			axios.get('/api/settings').then(response => {
				response.data.forEach(element => {
					this.settings[element.key] = element.value;
				});
			});

			this.loading = false;
		},

		save() {
			this.loading = true;

			axios.post('/api/settings', this.settings).then(() => {
				this.loading = false;
			}).catch(e => {
				this.loading = false;
				this.error = getError(e);
			});
		},

		savePassword() {
			if (this.password !== this.password_confirmation) {
				alert('Passwords do not match!');
				return;
			}
			if (confirm('Are you sure you want to edit the password of the administrator account?')) {
				this.loading = true;

				axios.post('/api/users/self/edit', {
					fullname: 'Admin',
					password: this.password,
					password_confirmation: this.password,
					phone: '0',
				}).then(() => {
					this.loading = false;
				}).catch(e => {
					this.loading = false;
					this.error = getError(e);
				});
			}
		}
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('sliderImages/fetchAll');
		await store.dispatch('companyValues/fetchAll');
		await store.dispatch('branchInfo/fetchAll');

		axios.get('/api/settings').then(response => {
			next(vm => {
				response.data.forEach(element => {
					vm.settings[element.key] = element.value;
				});
			});
		});
	},

	meta: {
		title: 'Settings',

		meta: [
			{ property: 'og:title', content: 'Settings / The Chair' },
		],
	},
};
</script>
